module.exports = __webpack_public_path__ + "static/media/WU_FORM_add_plus_expand.2c5c6620.svg";